import React from 'react';
import { Wifi, WifiOff, Upload, AlertCircle } from 'lucide-react';
import { useOfflineSync } from '../hooks/useOfflineSync';

const OfflineIndicator: React.FC = () => {
  const { isOnline, pendingSync, syncPendingEntries } = useOfflineSync();

  if (isOnline && pendingSync === 0) return null;

  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50">
      <div className={`flex items-center gap-3 px-4 py-2 rounded-full shadow-lg border transition-all duration-300 ${
        isOnline 
          ? 'bg-blue-50 border-blue-200 text-blue-800' 
          : 'bg-orange-50 border-orange-200 text-orange-800'
      }`}>
        {isOnline ? (
          <Wifi className="w-4 h-4" />
        ) : (
          <WifiOff className="w-4 h-4" />
        )}
        
        <span className="text-sm font-medium">
          {isOnline ? (
            pendingSync > 0 ? `Syncing ${pendingSync} items...` : 'Back online'
          ) : (
            'Offline mode'
          )}
        </span>

        {isOnline && pendingSync > 0 && (
          <button
            onClick={syncPendingEntries}
            className="flex items-center gap-1 px-2 py-1 bg-blue-100 hover:bg-blue-200 rounded-full transition-colors"
          >
            <Upload className="w-3 h-3" />
            <span className="text-xs">Sync</span>
          </button>
        )}

        {!isOnline && (
          <div className="flex items-center gap-1">
            <AlertCircle className="w-3 h-3" />
            <span className="text-xs">Data will sync when online</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default OfflineIndicator;